import React, { lazy, Suspense, useEffect } from 'react';
import {
	Switch,
	HashRouter as Router,
	Route,
	Redirect,
} from 'react-router-dom';

// Component
import ErrorBoundary from 'ErrorBoundary';
import ViewportRestrict from 'helper/component/viewport';
import Loader from 'helper/component/loader';
import NotFound from 'helper/component/404';
import LoadingScreen from 'helper/component/loadingscreen';
import { componentLoader, preload, sizing } from 'helper';

// REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


import { Sidebar, Modal } from 'components';
import { setToken } from 'redux/actions/auth';
import { getLocalize } from 'redux/actions/localize';

import images from 'helper/images.json';

// Pages
const Home = lazy(() => componentLoader(() => import('pages/Home')));
const Run  = lazy(() => componentLoader(() => import('pages/Run')));
const Shared  = lazy(() => componentLoader(() => import('pages/Shared')));

export const Main = ({ setToken, getLocalize }) => {
	useEffect(() => {
        preload([...images]);
        getLocalize();
		setToken();
        sizing();
        window.addEventListener('resize', sizing);
        return  () => window.removeEventListener('resize', sizing);
		// eslint-disable-next-line
	}, []);
	return (
		<Router basename='/' hashType={'noslash'}>
			<div id="Main" className="main-panel">
				<ErrorBoundary>
					<Suspense fallback={<LoadingScreen />}>
						<ViewportRestrict display={true} type="portrait" />
						<Loader />
						<Sidebar />
						<Modal />
						<div className="content-container">
							<Switch>
								<Route exact path="/" component={Home} />
								<Route exact path="/run" component={Run} />
								<Route exact path="/shared/:code" component={Shared} />
								<Redirect exact from="/shared" to={'/'} />
								<Route component={NotFound} />
							</Switch>
						</div>
					</Suspense>
				</ErrorBoundary>
			</div>
		</Router>
	);
};

const mapDispatchToProps = (dispatch) => ({
	...bindActionCreators({ setToken, getLocalize}, dispatch)
});

const mapStateToProps = (state) => ({
    event : state.localize.event
})

export default connect(mapStateToProps, mapDispatchToProps)(Main);
